import React from 'react';
import { Grid } from '@mui/material';
import { KeyFindingCard } from './KeyFindingCard';
import type { MarketReportKeyFinding } from '@horwath-htl/shared-types';

export interface KeyFindingsGridProps {
  findings: MarketReportKeyFinding[];
  columns?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
  };
}

export const KeyFindingsGrid: React.FC<KeyFindingsGridProps> = ({
  findings,
  columns = { xs: 12, sm: 6, md: 4, lg: 4 }
}) => {
  return (
    <Grid container spacing={3}>
      {findings.map((finding) => (
        <Grid item key={finding.id} {...columns}>
          <KeyFindingCard finding={finding} />
        </Grid>
      ))}
    </Grid>
  );
};